import { i18n } from '~/utils';

export const ledgerAccountImportHeaderFields = [
  'number',
  'name',
  'account_type',
  'cost_type',
  'valid_from',
] as const;

export const ledgerAccountImportMandatoryHeaderFields = ['number'] as const;

export const ledgerAccountImportDefaultColumnMapping = {
  account_type: i18n.t(($) => $.import.columnMapping.accountType, {
    ns: 'ledgerAccounts',
  }),
  cost_type: i18n.t(($) => $.import.columnMapping.costType, {
    ns: 'ledgerAccounts',
  }),
  name: i18n.t(($) => $.import.columnMapping.name, {
    ns: 'ledgerAccounts',
  }),
  number: i18n.t(($) => $.import.columnMapping.accountNumber, {
    ns: 'ledgerAccounts',
  }),
  valid_from: i18n.t(($) => $.import.columnMapping.validFrom, {
    ns: 'ledgerAccounts',
  }),
};
